import api from "../axios";
import baseUrl from "../baseUrl";

export default {
  // 发送验证码
  sendCode(params) {
    return api.post(baseUrl + "api/app/id_code/send", params);
  },
  // 获取企业行业信息
  getTrade() {
    return api.get(baseUrl + "api/sys/list/trade");
  },
  // 获取招聘类型、专业方向列表
  getTypeList(params) {
    return api.getParams(baseUrl + "api/sys/list", params);
  },
  // 省
  getProvince(params) {
    return api.get(baseUrl + "api/common/province/list", params);
  },
  // 市
  getCity(params) {
    return api.getParams(baseUrl + "api/common/city/list", params);
  },
  // 区
  getArea(params) {
    return api.getParams(baseUrl + "api/common/county/list", params);
  },
  getNum() {
    return api.get(baseUrl + `api/enterpise/website/profile`)
  },
  getXixunProvince() {
    return api.get(baseUrl + `api/common/area/xixun/province/list`)
  },
  getXixunCity(provinceId) {
    return api.get(baseUrl + `api/common/area/xixun/city/list/${provinceId}`)
  },
  getXixunCounty(cityId) {
    return api.get(baseUrl + `api/common/area/xixun/county/list/${cityId}`)
  },
  getSalaryList() {
    return api.get(`${baseUrl}api/common/sys/salary`)
  },
  // 获取岗位类型
  getJobType() {
    return api.get(`${baseUrl}api/common/job_type/list`)
  },
  // 获取学历类型
  getEducationList() {
    return api.get(`${baseUrl}api/common/education/list`)
  }
}